<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-camera`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.107 6.253A2 2 0 0116.962 5h14A2 2 0 0132.8 6.21L34 9h9.8c1.215 0 2.2.895 2.2 2v30c0 1.105-.985 2-2.2 2H4.2C2.985 43 2 42.105 2 41V11c0-1.105.985-2 2.2-2H14l1.107-2.747zM42 13H6v26h36V13zm-18 3c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 4a6 6 0 100 12 6 6 0 000-12z"/></svg>
</template>
<script>

export default {
  name: 'IconCamera',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
